<div class="client-facing-website">
  <app-main-header class="mobile-menu-wrapper"></app-main-header>
  <router-outlet></router-outlet>
  <tvb-footer></tvb-footer>
</div>
